import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import StocksType from './StocksType';
import latestStocks from './StocksMenuList'
import AiAssistantsModal from './AiAssistantsModal';

export default function SecFilingsSearch() {
  const [value, setValue] = React.useState<StocksType | null>(null);
  const [inputValue, setInputValue] = React.useState('');

  const [data, setData] = React.useState({
    ticker: "",
    company_name: "",
    open: "",
    change_percent: "",
    change: "",
    public_float: "",
    outstanding_shares: "",
    latest_volume: 0
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (value !== null) {
      const stockInput = e.currentTarget.querySelector('input[name="stock"]') as HTMLInputElement;
      if (stockInput) {
        stockInput.value = value.name;
      }
      e.currentTarget.submit();
    }
  }

  return (
    <div>
      <style>{`
        .dark-mode .MuiOutlinedInput-root {
          color: #e0e0e0;
        }
        .dark-mode .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
          border-color: #3a3b44;
        }
        .dark-mode .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
          border-color: #5a5b64;
        }
        .dark-mode .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: #b66dff;
        }
        .dark-mode .MuiInputLabel-root {
          color: #9c9fa6;
        }
        .dark-mode .MuiInputLabel-root.Mui-focused {
          color: #b66dff;
        }
        .dark-mode .MuiAutocomplete-paper {
          background-color: #2a2b32;
          color: #e0e0e0;
        }
        .dark-mode .MuiAutocomplete-option {
          color: #e0e0e0;
        }
        .dark-mode .MuiAutocomplete-option[data-focus="true"] {
          background-color: rgba(182, 109, 255, 0.12);
        }
        .dark-mode .MuiAutocomplete-option[aria-selected="true"] {
          background-color: rgba(182, 109, 255, 0.22);
        }
        .dark-mode .MuiAutocomplete-clearIndicator,
        .dark-mode .MuiAutocomplete-popupIndicator {
          color: #9c9fa6;
        }
        .dark-mode .MuiSvgIcon-root {
          color: #9c9fa6;
        }
      `}</style>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">SEC Filings</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">SEC Filings</h4>
              <p className="card-description"> Read, analyze and review SEC Filings with our AI assistant, June. <AiAssistantsModal message="Learn How it Works" /></p>
              <form className="forms-sample" action="/sec_filings_request" method="get" onSubmit={handleSubmit}>
                  <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setValue({
                          name: newValue,
                        });
                      } else if (newValue && newValue.inputValue) {
                        setValue({
                          name: newValue.inputValue,
                        });
                      } else {
                        setValue(newValue);
                        if (newValue) {
                          const stockInput = document.querySelector('input[name="stock"]') as HTMLInputElement;
                          if (stockInput) {
                            stockInput.value = newValue.name;
                          }
                          const form = document.querySelector('.forms-sample') as HTMLFormElement;
                          form?.submit();
                        }
                      }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    className="form-group"
                    options={latestStocks}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.name;
                    }}
                    renderOption={(option) => option.name}
                    fullWidth
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Find a company"
                        color="primary"
                        variant="outlined"
                        name="stock"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  <div className="form-group">
                    <button type="submit" className="btn btn-gradient-primary">Search</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
